import React from "react"
import { useTranslation } from "@root/misc/useTranslation"
import deFlag from "@images/language_switcher/de.svg"
import gbFlag from "@images/language_switcher/gb.svg"

interface Props {
  className?: string
}

export const LOCALES: { code: "de" | "en", flagSrc: string }[] = [
  { code: "de", flagSrc: deFlag },
  { code: "en", flagSrc: gbFlag },
]

export const switchLocale = (code: string) => {
  const url = new URL(window.location.href)
  url.searchParams.set("locale", code)
  window.location.href = url.toString()
}

const LanguageSwitcher = ({ className }: Props) => {
  const { locale, t } = useTranslation()

  return (
    <div className={["languageSwitcher", className].filter(Boolean).join(" ")}>
      {LOCALES.map(({ code, flagSrc }) => (
        <button
          key={code}
          type="button"
          className={`languageSwitcher__option${locale === code ? " languageSwitcher__option--active" : ""}`}
          aria-pressed={locale === code}
          aria-label={t(`language_switcher.${code}`)}
          disabled={locale === code}
          onClick={(event) => {
            event.stopPropagation()
            switchLocale(code)
          }}
        >
          <img className="languageSwitcher__optionFlag" src={flagSrc} alt={t(`language_switcher.${code}`)} width="26" height="13" />
        </button>
      ))}
    </div>
  )
}

export default LanguageSwitcher
